import { module } from 'modujs';
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin.js";
import { gsap } from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        gsap.registerPlugin(DrawSVGPlugin);

        gsap.config({
            nullTargetWarn: false
        });

        //config
        this.delay = this.getData('delay') || 0;

        this.duration = this.getData('duration') || 1;

        this.$path = this.el.querySelectorAll('path');

        //set path to 0
        gsap.set(this.$path, {
            drawSVG: 0
        });

        this.bindEvents();
    }

    ////////////////////
    // Events
    ////////////////////
    bindEvents() {

    }

    ////////////////////
    // Methods
    ////////////////////
    animatePath(event) {
        // console.log(event);
        if (event.obj.el != this.el) {
            return;
        }

        gsap.to(this.$path, {
            duration: this.duration,
            drawSVG: "100%",
            delay: this.delay,
            ease: "power2.out",
            stagger: .1
        });
    }

    destroy() {
        super.destroy();
    }
}
